// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mK3a","newExpiryDate":"styles_newExpiryDate__1Fw_u","footer":"styles_footer__1NebE"};